import React from 'react';
import PropTypes from 'prop-types';
import './breadcrumbs.scss';
import useTranslation from '../../../utils/translation-utils';
import Icon, { IconColors, IconSizes, IconTypes } from '../icon';

const BreadcrumbItemTypes = {
  SIMPLE_TEXT: 'simple-text',
  HOME: 'home',
  CUSTOM: 'custom',
};

const BreadcrumbItem = ({ label, type }) => {
  const [getTranslation] = useTranslation();

  switch (type) {
    case BreadcrumbItemTypes.HOME:
      return <Icon type={IconTypes.HOME} size={IconSizes.MEDIUM} color={IconColors.GREY} />;
    case BreadcrumbItemTypes.CUSTOM:
      return 'Custom'; // TODO: Add custom logic as required
    case BreadcrumbItemTypes.SIMPLE_TEXT:
    default:
      return getTranslation(label);
  }
};

BreadcrumbItem.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BreadcrumbItemTypes)),
};

BreadcrumbItem.defaultProps = {
  label: '',
  type: BreadcrumbItemTypes.SIMPLE_TEXT,
};

export {
  BreadcrumbItem as default,
  BreadcrumbItemTypes,
};
